import Header from './Header';
import { useLocation } from 'react-router-dom';
import { useIsMobile } from '../hooks/useIsMobile';
import { theme, fonts } from '../styles/theme';

const GLOBAL_STYLES = `
  @keyframes shellFadeUp {
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
  }

  @keyframes subtlePulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.55; }
  }

  .v2-ani { opacity: 0; animation: shellFadeUp 0.42s ease forwards; }
  .v2-d1 { animation-delay: 0.03s; }
  .v2-d2 { animation-delay: 0.06s; }
  .v2-d3 { animation-delay: 0.09s; }
  .v2-d4 { animation-delay: 0.12s; }
  .v2-d5 { animation-delay: 0.15s; }
  .v2-d6 { animation-delay: 0.18s; }
  .v2-d7 { animation-delay: 0.21s; }
  .v2-d8 { animation-delay: 0.24s; }

  ::-webkit-scrollbar { width: 8px; height: 8px; }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb {
    background: var(--app-border);
    border-radius: 999px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: var(--app-text-faint);
  }
`;

const AppLayout = ({ children }) => {
  const { pathname } = useLocation();
  const isMobile = useIsMobile();

  return (
    <div
      style={{
        minHeight: '100vh',
        background: theme.bg,
        color: theme.textMain,
        fontFamily: fonts.main,
        transition: 'background-color 0.18s ease, color 0.18s ease',
      }}
    >
      <style>{GLOBAL_STYLES}</style>

      <Header isMobile={isMobile} sticky={!pathname.startsWith('/schwab')} />

      <main
        style={{
          minHeight: 'calc(100vh - 112px)',
        }}
      >
        {children}
      </main>

      <footer
        style={{
          padding: isMobile ? '20px 16px 28px' : '20px 24px 30px',
        }}
      >
        <div
          style={{
            maxWidth: 1600,
            margin: '0 auto',
            borderTop: `1px solid ${theme.borderSub}`,
            paddingTop: 14,
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: 8,
            justifyContent: 'space-between',
            color: theme.textFaint,
            fontSize: 12,
          }}
        >
          <span>Internal dashboard preview environment for CNRF operations.</span>
          <span style={{ fontFamily: fonts.mono }}>
            {new Date().toLocaleDateString('en-US')} · PRE-LIVE UI
          </span>
        </div>
      </footer>
    </div>
  );
};

export default AppLayout;
